<template>
  <div
    class="hero work-here"
    :class="{ layout, slide, 'video-content': video }"
    :style="{ height, position, top }"
  >
    <div class="text flex-column justify-content-center align-items-center home-search">
      <h1
        class="text-white m-0"
        data-aos="fade-down"
        data-aos-duration="1000"
        v-html="title"
      ></h1>
      <div class="search d-flex justify-content-center align-items-center" v-if="searchBox"  data-aos="fade-up"
        data-aos-duration="1000">
        <input
          type="text"
          placeholder="digite o nome da vaga"
          v-model="search"
          @keypress.enter="search ? $router.push(`/vagas?busca=${search}`) : ''"
        />
        <button @click="search ? $router.push(`/vagas?busca=${search}`) : ''">
          &nbsp; <img src="@/assets/images/search.svg" alt="" />
        </button>
      </div>
    </div>

    <div class="media-content" :class="{ 'v-content': video }">
       <!-- Image -->
      <div class="img img-hero" v-if="!slide">
        <img
          :src="require(`@/assets/images/restoque/${image}`)"
          v-if="image"
          class="rounded shadow-lg"
        />
      </div>
       <!-- Video -->
      <div class="bg-video">
        <video autoplay loop="" playsinline="" muted="" v-if="video">
          <source
            src="https://s3.amazonaws.com/uploads.restoque.luby.com.br/restoque-estagio.mp4"
          />
        </video>
      </div>
      <!-- Slide -->
      <div
        class="swiper-container swiper2 mySwiper2"
        ref="mySwiper2"
        v-if="slide"
      >
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in slide" :key="index">
            <div class="here-card">
              <div class="container">
                <p v-if="item.title">
                  {{ item.title }}
                </p>
              </div>
              <img
                :src="require(`@/assets/images/restoque/${item.img}`)"
                v-if="item.img"
                class="rounded shadow-lg"
              />
            </div>
          </div>
        </div>
        <div class="swiper-pagination"  data-aos="fade-up"
        data-aos-duration="1000" ref="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchJob from "@/components/jobs/SearchJob.vue";
import Swiper from "swiper";
// import Swiper styles
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay]);
export default {
  name: "Hero",
  data() {
    return {
      search: "",
    }
  },
  props: {
    title: String,
    slideTitle: String,
    video: String | Boolean,
    image: String,
    layout: String,
    height: null,
    position: null,
    vagas: false,
    top: null,
    slide: false,
    searchBox: false
  },

  mounted() {
    this.start();
  },

  methods: {
    start() {
      var swiper = new Swiper(this.$refs["mySwiper2"], {
        slidesPerView: 1,
        spaceBetween: 0,

        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        pagination: {
          el: this.$refs["swiper-pagination"],
          clickable: true,
        },
        // navigation: {
        //   nextEl: this.$refs["swiper-button-next"],
        //   prevEl: this.$refs["swiper-button-prev"],
        // },
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
      });
    },
  },

  components: {
    SearchJob,
  },
};
</script>

<style lang="scss">
.swiper-wrapper {
  height: auto;
}

.here-card {
  .container {
    position: absolute;
    margin: 0 auto;
    left: 0;
    right: 0;
    background-color: transparent;
    top: 50%;
    height: 100px;
    transform: translateY(-50%);
    z-index: 999;
    box-sizing: border-box;
    text-align: left !important;
  }
  p {
    z-index: 99999;
    color: #fff;
    left: 0;
    max-width: 400px !important;
    margin-left: 3%;
  }
}

.img-hero {
  @include media-breakpoint-down(md) {
    height: auto;
    display: flex;
    justify-content: center;
    text-align: center;
    img {
      height: 100vh !important;
      width: auto;
      max-width: 1920px;
      display: block;
      margin: 0 auto;
      text-align: center;
    }
  }
  &:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }
}

.bg-video {
  position: relative;
  video {
    width: 100%;
  }
  &:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.1);
  }
}

.mySwiper2 {
  width: 100%;
  max-height: 100vh;
  position: relative;
  text-align: center;
  @include media-breakpoint-down(md) {
    height: auto;
    display: flex;
    justify-content: center;
    text-align: center;
    img {
      height: 100vh !important;
      width: auto;
      max-width: 1920px;
      display: block;
      margin: 0 auto;
      text-align: center;
    }
  }
  z-index: 9;
  position: relative !important;
  .swiper-slide {
    &:after {
      content: "";
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      z-index: 9;
      background-color: rgba(0, 0, 0, 0.6);
    }
  }
}

.logos {
  position: absolute;
  left: -12%;
  top: 7.5rem;
  width: 50%;
  max-width: 780px;
  z-index: 99;
  @media screen and (max-width: 1400px) {
    width: 50%;
    max-width: 580px;
  }
}

.hero {
  width: 100vw;
  height: 100vh;
  &.video-content {
    @include media-breakpoint-down(md) {
      height: auto;
    }
  }
  &.slide {
    height: auto !important;
    position: relative;
    & > .media-content,
    & > .media-content > img,
    & > .media-content > video {
      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: auto !important;
    }
  }
  top: 0;
  min-height: 400px;
  @include media-breakpoint-down(md) {
    min-height: 100px;
  }
  // max-height: 700px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 9;

  &__vagas {
    width: 80%;
    max-width: 400px;
    text-align: left;
    z-index: 99;
    position: absolute;
    top: 40%;
    @include media-breakpoint-down(md) {
      top: 30%;
    }
    p {
      color: #fff;
      max-width: 400px;
      font-size: 1.2rem;
    }
  }

  &.md {
    height: 40vh;
    min-height: auto;
    overflow: unset;

    & > .media-content {
      width: 100vw;

      top: 0;
      left: 0;
    }
  }

  &.half {
    height: 50vh;
    min-height: auto;
    overflow: unset;

    & > .media-content {
      width: 100vw;

      top: 0;
      left: 0;
    }
  }

  & > .text {
    z-index: 999;
    position: absolute;
    .input-group {
      .form-control,
      .btn {
        height: calc(4rem + 2px);
        display: flex;

        &::placeholder {
          opacity: 0.5;
        }
      }
    }

    h1 {
      font-size: 3.9rem;
      font-weight: 500;
      text-align: center;
      line-height: calc(3.9rem * 1.3);
      strong {
        font-weight: 600;
        color: theme-color(primary);
      }

      small {
        display: block;
        font-family: "Nunito-light";
        font-size: 2.2rem;
        line-height: calc(2.2rem * 1.1);
      }

      @include media-breakpoint-down(md) {
        font-size: 2rem;
        line-height: calc(2rem * 1.3);
      }
    }
  }

  .slide-text {
    position: absolute;
    font-size: 3.9rem;
    font-weight: 500;
    z-index: 9999;
    top: 40%;
    transform: translate(-50%);
    color: #fff;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
    line-height: calc(3.9rem * 1.3);
    strong {
      font-weight: 600;
      color: theme-color(primary);
    }

    small {
      display: block;
      font-family: "Nunito-light";
      font-size: 2.2rem;
      line-height: calc(2.2rem * 1.1);
    }

    @include media-breakpoint-down(md) {
      font-size: 2rem;
      line-height: calc(2rem * 1.3);
    }
  }

  & > .media-content,
  & > .media-content > img,
  & > .media-content > video {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: middle;
    overflow: hidden;
    @include media-breakpoint-down(md) {
    }
  }

  & > .media-content.v-content,
  & > .media-content > video {
    @include media-breakpoint-down(md) {
      height: auto !important;
      position: relative !important;
    }
  }

  *::-webkit-media-controls-panel {
    display: none !important;
    -webkit-appearance: none;
  }

  *::--webkit-media-controls-play-button {
    display: none !important;
    -webkit-appearance: none;
  }

  *::-webkit-media-controls-start-playback-button {
    display: none !important;
    -webkit-appearance: none;
  }
}


.home-search {
    display: block;
    z-index: 99;
    overflow: hidden;
    position: relative;
    width: 100%;
    .search {
      width: 90%;
      max-width: 800px;
      border-radius: 100px;
      margin: 0 auto;
      margin-top: 1.7rem;
      input {
        height: 70px;
        box-sizing: border-box;
        width: calc(100% - 8rem);
        background-color: rgba(#fff,.8);
        border-radius: 4px;
        border: none;
        font-size: 1.8rem;
        padding: 0px 1rem 0px 2rem;
        &::-webkit-input-placeholder {
          /* Chrome/Opera/Safari */
          color: rgba(#000, 0.45);
        }
        &::-moz-placeholder {
          /* Firefox 19+ */
          color: rgba(#000, 0.45);
        }
        &:-ms-input-placeholder {
          /* IE 10+ */
          color: rgba(#000, 0.45);
        }
        &:-moz-placeholder {
          /* Firefox 18- */
          color: rgba(#000, 0.45);
        }
            @include media-breakpoint-down(sm) { 
               height: 40px;
        box-sizing: border-box;
        width: 100%;
        padding-right: 3rem;
           font-size: 1.2rem;
            }
      }
      button {
        padding: 0px;
        background-color: transparent;
        border: transparent;
        width: 4rem;
        margin-left: -4.3rem;
        img {
          width: 2rem;
        }
      }
    }
  }
</style>
